<template>
  <div class="layer layer2 setTimes">
    <div class="inner">
      
      <div class="selectTime">
        <select class="input inlineInput" v-model="setTime.from.hh">
          <option v-for="hh in timeSlot.hour" :key="hh" :value="hh">{{ hh }}</option>
        </select>
        :
        <select class="input inlineInput" v-model="setTime.from.mm">
          <option v-for="mm in timeSlot.minute" :key="mm" :value="mm">{{ mm }}</option>
        </select>
        <span class="sp"> - </span>
        <select class="input inlineInput" v-model="setTime.to.hh">
          <option v-for="hh in timeSlot.hour" :key="hh" :value="hh">{{ hh }}</option>
        </select>
        :
        <select class="input inlineInput" v-model="setTime.to.mm">
          <option v-for="mm in timeSlot.minute" :key="mm" :value="mm">{{ mm }}</option>
        </select>
        <p v-if="!validateSetTime" class="colorRed mt5">ⓘ {{locale.message_available_endtime}}</p>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click.stop="close">{{ locale.cancel }}</button>
        <button type="button" :disabled="!validateSetTime" class="btn" @click.stop="applyTime">{{ locale.apply }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SetAvailableTimeEdit',
  props: [
    'locale',
    'timeValue'
  ],
  computed: {
    validateSetTime () {
      const from = this.timeToNum(this.setTime.from)
      const to = this.timeToNum(this.setTime.to)
      return from < to
    }
  },
  created () {
    this.setTimeSlot()
    if (this.timeValue) {
      this.setTime = this._.cloneDeep(this.timeValue)
    }
  },
  data () {
    return {
      setTime: {
        from: {
          hh: '00',
          mm: '00'
        },
        to: {
          hh: '24',
          mm: '00'
        }
      },
      timeSlot: {
        hour: [],
        minute: []
      }
    }
  },
  methods: {
    setTimeSlot () {
      for (let i = 0; i <= 24; i++) {
        this.timeSlot.hour.push(`${('0' + i).slice(-2)}`)
      }
      for (let i = 0; i <= 5; i++) {
        this.timeSlot.minute.push(`${('0' + i * 10).slice(-2)}`)
      }
    },
    timeToNum (time) { // time: {hh: '00', mm: '00'}
      const times = time.hh + time.mm
      return parseInt(times)
    },
    applyTime () {
      this.$emit('apply', this.setTime)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.setTimes {
  box-shadow: 0 0 10px rgba(0,0,0,0.5);
  .inner {
    width: auto;
    max-width: none;
  }
  .selectTime {
    margin-bottom: 16px;
  }
  .btns {
    text-align: center;
  }
  .btn + .btn {
    margin-left: 4px;
  }
}
</style>
